/**
 * ReportEditor - 报告编辑器组件
 * 包含 Logo 和 Markdown 编辑器
 */
import React, { forwardRef } from 'react';
import { isEmpty } from 'lodash-es';
import classNames from 'classnames';
import Abnormal from '@home/components/Abnormal';
import { IReportEditorProps } from '../types';
import dataBrainIcon from '@/pages/aigc/pages/Agent/svg/databrian_logo_text.png';
import './ReportEditor.scss';

// 定义 MarkdownEditor 组件的 Props 类型
interface IMarkdownEditorProps {
  value: string;
  answer?: unknown;
}

// 定义 MarkdownEditor 的 Ref 类型
interface IMarkdownEditorRef {
  getMarkdown: () => Promise<string>;
  handleSetHtml: () => void;
  /** 查询用户是否编辑过内容（自上次 resetDirty 以来） */
  isDirty?: () => boolean;
  /** 重置脏标记（保存成功或文档重新加载后调用） */
  resetDirty?: () => void;
}

interface IReportEditorInternalProps extends IReportEditorProps {
  /** Markdown 编辑器组件 */
  MarkdownEditorComponent: React.ForwardRefExoticComponent<
  IMarkdownEditorProps & React.RefAttributes<IMarkdownEditorRef>
  >;
}

export const ReportEditor = forwardRef<IMarkdownEditorRef, IReportEditorInternalProps>(
  (
    {
      content,
      answer,
      isLoading,
      logoContainerRef,
      reportContainerRef,
      className,
      MarkdownEditorComponent,
    },
    markdownRef
  ) => (
    <div className={classNames('dba-report-editor',"dba-chat-ds-report-page-right-markdown-box", className)}>
      <div ref={logoContainerRef} className="dba-report-editor__content">
        {/* Logo 区域 */}
        <div className="dba-report-editor__logo">
          <img
            src={dataBrainIcon}
            className="dba-report-editor__logo-img"
            crossOrigin="anonymous"
            alt="DataBrain"
          />
        </div>

        {/* Markdown 编辑器区域 */}
        {/* 保留原有类名 dba-chat-ds-report-page-right-markdown-report 用于 MarkdownEditor 内部的 DOM 选择器 */}
        <div ref={reportContainerRef} className="dba-report-editor__markdown dba-chat-ds-report-page-right-markdown-report">
          <Abnormal
            component={
              <MarkdownEditorComponent
                value={content}
                ref={markdownRef}
                answer={answer}
              />
            }
            isLoading={isLoading}
            isError={false}
            isNoData={isEmpty(content)}
          />
        </div>
      </div>
    </div>
  )
);

ReportEditor.displayName = 'ReportEditor';

export default ReportEditor;
